export default {
    excess: 'Надвишена отговорност',
    security: 'Депозит за сигурност',
    fuel_policy: 'Политика за гориво',
    like_for_like: 'Със същото за същото',
    full_to_full: 'Пълен до пълен',
    mileage: 'Пробег: {mileage} мили на наем',
    unlimited_mileage: 'Неограничен пробег',
    non_refundable: 'Без възстановяване',
    free_cancellation_until: 'Безплатно анулиране до {date}',
    cancellation_with_terms: 'Анулиране {0} съгласно ',
    t_c_text: 'Общи условия',
    two_free_extras: 'Два безплатни екстри при получаване',
    glass_tyres_covered: 'Покрити стъкла и гуми',
    spec_fuel_petrol: 'бензин',
    spec_fuel_petrol_diesel: 'бензин/дизел',
};
